import AbstractOpenApiRequest from "~/ts/library/openApi/AbstractOpenApiRequest";
import {AbstractEntityBuilder} from "~/ts/library/AbstractEntity";
import {ApiRequestConfig} from "~/core-ui/ts/request/AbstractApiRequest";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import {
    MAKE_OPERATOR_LOGOUT,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import Delay from "~/ts/library/Delay";

export default class OperatorApiRequest<DataType extends object> extends AbstractOpenApiRequest<DataType> {
    private operatorSessionUid: string;

    private checkSessionUid = true;


    constructor(options: ApiRequestConfig, dataType?: AbstractEntityBuilder<DataType>) {
        super(options, dataType);
        this.operatorSessionUid = OperatorAccountStore.sessionUid.value;
        this.addHeader("X-Language", OperatorApplicationConfigInstance.languageId);
        this.setCredentials(OperatorAccountStore.login.value, OperatorAccountStore.password.value, OperatorAccountStore.tokenId.value);
    }


    private static get productionHost() {
        return `https://${OperatorApplicationConfigInstance.productionHost}`;
    }

    public static getHost(): string {
        let productionHost = this.productionHost;
        if (OperatorApplicationConfigInstance.isNative) {
            return OperatorConfigStore.isProduction.value ? productionHost : "http://me-talk.ru:8088";
        } else {
            if (CORE_UI_PRODUCTION && !OperatorAccountStore.isCabinetIframe) {
                return productionHost;
            }
            return "";
        }
    }

    protected getUrl(path: string): string {
        return `${OperatorApiRequest.getHost()}/json/v1.0/operatorApplication${path}`;
    }

    setCredentials(login: string, password: string, tokenId: string) {
        if (OperatorAccountStore.isCabinetIframe) {
            this.addHeader("X-Token", JSON.stringify({
                'cabinet-session': true,
                tokenId
            }));
            this.setCheckSessionUid(false);
        } else {
            this.addHeader("X-Token", encodeURIComponent(JSON.stringify({
                login, password, tokenId
            })));
        }
        return this;
    }

    setCheckSessionUid(value: boolean) {
        this.checkSessionUid = value;
        return this;
    }


    async send<T>(): Promise<OpenApiResult<DataType>> {
        if (OperatorApplicationConfigInstance.isInited) {
            let result: OpenApiResult<DataType>;
            result = await super.send();
            if (!this.checkSessionUid || this.operatorSessionUid == OperatorAccountStore.sessionUid.value) {
                return result;
            } else {
                throw new Error("За время запроса изменилась сессия оператора");
            }
        } else {
            await Delay.make(100);
            return await this.send();
        }
    }

    protected validateStatus(status: number): boolean {
        if (status == 401) {
            if (!OperatorAccountStore.isAuthorized.value || OperatorAccountStore.isCabinetIframe) {
                return true;
            }
            OperatorApplicationEventManager.emit(MAKE_OPERATOR_LOGOUT, __("Соединение разорвано"));
            //operatorLogout(__("Соединение разорвано"));
            this.options.silentError = true;

        }
        return super.validateStatus(status);
    }
}